import { useCallback, useEffect, useState } from 'react';
import { applySelectionHighlight, SelectionHighlight } from './selectionHighlight';

// I DUE MODI DI DISEGNARE LA SCENA, non due ambienti fra cui scegliere.
//
// Editor è il modo di chi lavora: luce neutra da studio, niente antialiasing, l'alone della
// selezione acceso. Viewer è la scena come la vedrà chi compra: l'environment del prodotto, il
// pavimento, l'antialiasing — e nessun alone, che al cliente non esiste.
//
// NEL MOTORE SONO DUE NUMERI (`EnvironmentMode`: 1 e 2), e la verità sta lì: questo stato serve
// solo a disegnare il tasto premuto, e si rilegge dal motore ogni volta che l'editor cambia.
const EDITOR = 1;
const VIEWER = 2;

const isOn = (sceneEditor: any) => (sceneEditor?.envMode ?? EDITOR) === VIEWER;

export const useSceneBackground = (sceneEditor: any, selectionHighlight: SelectionHighlight) => {
    const [backgroundOn, setBackgroundOn] = useState(false);

    useEffect(() => {
        if (sceneEditor) setBackgroundOn(isOn(sceneEditor));
    }, [sceneEditor]);

    const toggleBackground = useCallback(() => {
        if (!sceneEditor) return;

        const next = isOn(sceneEditor) ? EDITOR : VIEWER;
        sceneEditor.setEnvironmentMode?.(next);
        // Nel Viewer il motore butta via l'alone, e tornando nell'Editor non lo rimette.
        if (next === EDITOR) applySelectionHighlight(sceneEditor, selectionHighlight);
        setBackgroundOn(next === VIEWER);
    }, [sceneEditor, selectionHighlight]);

    return [backgroundOn, toggleBackground] as const;
};
